import { createContext } from 'react';

interface IFormContext {
  formData: any;
  formErrors: any;
  setFormData: Function;
  setFormErrors: Function;
}

export const FormContext = createContext<IFormContext>({} as any);
